import Header from "../../components/Header/Header";
import SearchInput from "../../features/AfterService/components/SearchInput/SearchInput";
import AfterServiceList from "../../features/AfterService/components/AfterServiceList/AfterServiceList";
import LabelInfo from "../../features/AfterService/components/LabelInfo/LabelInfo";
import ResultInform from "../../components/ResultInform/ResultInform";

// import useAsAgentSearch from "../../features/AfterService/hooks/useAsAgentSearch";
import useAsAgentSearch from "#features/AfterService/hooks/useAsAgentSearch";
import AfterServiceSkeleton from "../../components/Skeleton/AfterServiceSkeleton";

const AfterServicePage = () => {
  const {
    formData,
    handleChange,
    search,
    activeTab,
    handleTabClick,
    categoryKeys,
    clearInput,
    infinity,
    agentList,
    fetchMoreData,
    loading,
    loaded,
  } = useAsAgentSearch();
  return (
    <section className="pb-24 p-hasHeader">
      <Header title="A/S업체 안내" />

      {/* 검색 탭 & 인풋 */}
      <SearchInput
        activeTab={activeTab}
        handleTabClick={handleTabClick}
        formData={formData}
        handleChange={handleChange}
        search={search}
        categoryKeys={categoryKeys}
        clearInput={clearInput}
      />

      {/* 스켈레톤 로더 */}
      {loading && agentList.length === 0 && <AfterServiceSkeleton />}

      {/* 리스트 */}
      {loaded && agentList !== null && agentList.length > 0 && (
        <AfterServiceList
          agentList={agentList}
          infinity={infinity}
          fetchMoreData={fetchMoreData}
          formData={formData}
        />
      )}

      {/* 검색결과가 없을경우 */}
      {!loading && loaded && (agentList === null || agentList.length === 0) && (
        <ResultInform
          label={
            <>
              검색 결과를 <br /> 찾을 수 없습니다.
            </>
          }
        />
      )}

      {/* 라벨인포 */}
      <LabelInfo />
    </section>
  );
};

export default AfterServicePage;
